import React from "react";


import APPLICATION_ROUTER_INTERFACE from "@ROUTER/Interfaces/Router";

import APPLICATION_ROUTER from "@ROUTER";


export const ApplicationRouterContext = React.createContext<APPLICATION_ROUTER_INTERFACE>(APPLICATION_ROUTER);


export {
    APPLICATION_ROUTER
};


export default ApplicationRouterContext;
